import PlacesAutocomplete, {
  geocodeByAddress,
} from 'react-places-autocomplete';
import "./GoogleAutocomplete.css"

interface googlePlaceAutoCompleteProps{
formik:any,
fieldName:string,
ref?:any,
cityFieldName?:string,
zipcodeFieldName?:string,
stateFieldName?:string
addressFieldName:string
}

const GooglePlaceAutocomplete=({formik,fieldName,ref,zipcodeFieldName,cityFieldName,stateFieldName,addressFieldName}:googlePlaceAutoCompleteProps)=>{

    const handleSelect=async (value:string) =>{
        const results:any = await geocodeByAddress(value);
        const {address_components}=results[0]
        const zipcode=await address_components?.filter((details:any)=>details.types[0]==='postal_code')[0]?.long_name
        const state = await address_components?.filter((details:any)=>details.types[0]==='administrative_area_level_1')[0]?.long_name
        const city = await address_components?.filter((details:any)=>details.types.includes('locality'))[0]?.long_name
        await formik.setFieldValue(addressFieldName,value)
        await formik.setFieldValue(stateFieldName,Boolean(state)?state:"")
        await formik.setFieldValue(zipcodeFieldName,Boolean(zipcode)?zipcode:"")
        await formik.setFieldValue(cityFieldName,Boolean(city)?city:"")
        formik.setFieldValue(fieldName,value.split(",")[0])
    }
    return(
        <PlacesAutocomplete
        value={formik.values[fieldName]}
        onChange={(address:string)=>{formik.setFieldValue(fieldName,address)}}
        onSelect={handleSelect}
        searchOptions={{
          componentRestrictions: { country: "us" },
          types: ['address'],
        }}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <input
            id={fieldName}
              ref={Boolean(ref)?ref:null}
              {...getInputProps({
                placeholder: 'Search address ...',
                className: 'location-search-input form-control form-control-lg form-control-solid',
              })}
            />
            <div className="autocomplete-dropdown-container">
              {loading && <div>Loading...</div>}
              {suggestions.map(suggestion => {
                const className = suggestion.active
                  ? 'suggestion-item--active'
                  : 'suggestion-item';
                // inline style for demonstration purpose
                const style = 
                   { cursor: 'pointer' }
                  
                return (
                  <div
                    {...getSuggestionItemProps(suggestion, {
                      className,
                      style,
                    })}
                  >
                    <span>{suggestion.description}</span>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    )
}
export default GooglePlaceAutocomplete